export function parseSearch(search: string): { [key: string]: any } {
  try {
    return (search.startsWith('?') ? search.slice(1) : search)
      .trim()
      .split('&')
      .map(xs => xs.split('=').map(segment => segment.trim()))
      .reduce((acc, cur) => {
        const [key, rawValue] = cur

        const parseValue = rawValue === undefined ? true : decodeURIComponent(rawValue)

        const finalValue = acc[key]
          ? Array.isArray(acc[key]) ? [...acc[key], parseValue] : [acc[key], parseValue]
          : parseValue

        return {
          ...acc,
          [key]: finalValue,
        }
      }, {})
  } catch (err) {
    console.error(err)
    return {}
  }
}

export function parseSdkUrl(url: string) {
  const reg = /.*\.(msstatic|huya)\.com\/\d+\/([^/]*)\//ig

  const result = reg.exec(url)
  return result?.[2] || 'unknown'
}

export function getCookie(doc: Document, name: string) {
  const result = doc.cookie.match(
    '(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)'
  )
  return result ? result.pop() : ''
};
